import React from "react";
import Multiselect from "multiselect-react-dropdown";

function getItemLabel(item, displayValue) {
  if (!item) {
    return "";
  }
  return (
    item[displayValue] ||
    item.label ||
    item.title ||
    item.name ||
    String(item)
  );
}

function ProviderFormMultiselect({
  options = [],
  selectedValues = [],
  onSelect,
  onRemove,
  displayValue = "label",
  placeholder = "Please Select",
  groupBy,
  className = "",
}) {
  const selected = Array.isArray(selectedValues) ? selectedValues : [];
  const count = selected.length;
  const inputPlaceholder =
    count > 0 ? `${count} selected — search or add more` : placeholder;

  const handleRemoveOne = (index) => {
    const removed = selected[index];
    const next = selected.filter((_, itemIndex) => itemIndex !== index);
    onRemove?.(next, removed);
  };

  return (
    <div className="cms-provider-form-multiselect-field">
      <Multiselect
        options={options}
        selectedValues={selected}
        className={`cms-provider-add-multiselect cms-provider-add-multiselect--clean ${className}`.trim()}
        placeholder={inputPlaceholder}
        displayValue={displayValue}
        groupBy={groupBy}
        onSelect={onSelect}
        onRemove={onRemove}
        closeIcon="circle"
        showCheckbox={true}
        showArrow={false}
        hidePlaceholder={false}
      />

      {count > 0 && (
        <div className="cms-provider-form-multiselect-selected">
          <p className="cms-provider-form-multiselect-selected-label">
            Selected ({count})
          </p>
          <ul className="cms-provider-form-multiselect-selected-list">
            {selected.map((item, index) => {
              const label = getItemLabel(item, displayValue);
              return (
                <li
                  key={`${label}-${index}`}
                  className="cms-provider-form-multiselect-selected-item"
                >
                  <span className="cms-provider-form-multiselect-selected-text">
                    {label}
                  </span>
                  <button
                    type="button"
                    className="cms-provider-form-multiselect-selected-remove"
                    onClick={() => handleRemoveOne(index)}
                    aria-label={`Remove ${label}`}
                  >
                    ×
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
}

export default ProviderFormMultiselect;
